define(["./nlgAnalysisTreeModule", "angular", "../arrays/arrays"], function (nlgAnalysisTreeModule, angular, arrays) {
    "use strict";

    return nlgAnalysisTreeModule.service("nodePropertyFormatter", [
        "entityFormatFilter",
        "numberFilter",
        "currencyFilter",
        "dimensionFilter",
        "dateFilter",
        "durationFilter",
        "translateFilter",
        "sanitizeService",
        function (entityFormatFilter, numberFilter, currencyFilter, dimensionFilter, dateFilter, durationFilter, translateFilter, sanitizeService) {
            return function nodePropertyFormatter(property) {

                var value = property.value;

                if (arrays.isArray(property.value)) {
                    return arrays.map(property.value, function (value) {
                        return nodePropertyFormatter({
                            type: property.type,
                            value: value
                        });
                    }).join(", ");
                }

                if (angular.isUndefined(value) || value === null) {
                    return "N/A";
                } else if (property.type === "ENTITY") {
                    return entityFormatFilter(value);
                } else if (property.type === "NUMBER") {
                    return numberFilter(value);
                } else if (property.type === "CURRENCY") {
                    return currencyFilter(value, "R$ ");
                } else if (property.type === "GLOBALCURRENCY") {
                    return currencyFilter(value, property.currency + " ");
                } else if (property.type === "DIMENSION") {
                    return dimensionFilter(value);
                } else if (property.type === "DATETIME") {
                    return dateFilter(value, "short");
                } else if (property.type === "DATE") {
                    return dateFilter(value, "shortDate");
                } else if (property.type === "TIME") {
                    return dateFilter(value, "shortTime");
                } else if (property.type === "INTERVAL") {
                    return dateFilter(value.start, "short") + " - " + dateFilter(value.end, "short");
                } else if (property.type === "ACTION") {
                    return nodePropertyFormatter(property.innerNodeProperty);
                } else if (property.type === "DURATION") {
                    return durationFilter(value);
                } else if (property.type === "BOOLEAN") {
                    return translateFilter("nodeproperty.boolean." + value);
                } else if (property.type === "HTML") {
                    return sanitizeService("<span>" + translateFilter(value, escapeSelector(property.messageArguments)) + "<span>");
                } else if (property.type === "URL") {
                    return sanitizeService(value);
                } else if (typeof value === "string") {
                    return sanitizeService(translateFilter(value));
                }
                return sanitizeService(angular.toJson(value));
            };

            function escapeSelector(messageArguments) {
                var newMessageArguments = [];
                messageArguments.forEach(function (argument) {
                    newMessageArguments.push(argument.replace(/[.*+?^${}()|/]/g, "\\$&"));
                });
                return newMessageArguments;
            }
        }]);
});